<template>
  <div class="tt-echart" :style="heightStyle" />
</template>
<script>
import echarts from 'echarts/lib/echarts'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/legendScroll'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/pie'
import 'echarts/lib/chart/line'
import 'echarts/lib/chart/scatter'

export default {
  name: 'EChart',
  props: {
    options: Object,
    height: Number,
    width: Number
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.initChart()
  },
  beforeDestroy() {
    this.dispose()
  },
  computed: {
    heightStyle() {
      let height = '230px'
      if (this.height) {
        height = `${this.height}px`
      }

      let width = '350px'
      if (this.width) {
        width = `${this.width}px`
      }
      return 'height:' + height + '; width:' + width
    }
  },
  methods: {
    initChart() {
      const chart = echarts.init(this.$el)
      chart.setOption(this.options)
      this.chart = chart
    },
    dispose() {
      this.chart && this.chart.dispose()
      this.chart = null
    },
    resize(...args) {
      this.chart && this.chart.resize(...args)
    }
  },
  watch: {
    options() {
      this.initChart()
    },
    width() {
      this.resize()
    },
    height() {
      this.resize()
    }
  }
}
</script>
<style lang="less">
.tt-echart {
  flex: 1;
  margin: 0 auto;
}
</style>
